import { SimpleButton } from "components/simpleButton/simpleButton";

export const JoinButton = ({ onClickJoin }: { onClickJoin: () => void }) => {
  return (
    <SimpleButton
      variant="primary"
      accent="sifted"
      size="lg"
      className="w-full min-w-[220px] md:w-auto"
      onClick={onClickJoin}
    >
      Join now
    </SimpleButton>
  );
};
